import { createApp } from 'vue'

export default defineNuxtPlugin({
  name: 'realtime-dev-status',
  setup() {
    if (!process.client) return
    const runtimeConfig = useRuntimeConfig()
    const isDev = process.dev === true
    const vms = runtimeConfig.public.features?.vms === true
    if (!isDev || !vms) return

    // Mount a small floating dev status widget in the app shell
    const app = useNuxtApp()
    app.hook('app:mounted', async () => {
      try {
        const mount = document.createElement('div')
        mount.id = 'realtime-dev-status-mount'
        document.body.appendChild(mount)

        const Comp = (await import('~/layers/base/components/RealtimeDevStatus.client.vue')).default
        const vm = createApp(Comp)
        vm.mount(mount)
      } catch {
        // ignore
      }
    })
  }
})


